import { render, staticRenderFns } from "./SearchSales.vue?vue&type=template&id=2cbd8572&scoped=true"
import script from "./SearchSales.vue?vue&type=script&lang=js"
export * from "./SearchSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbd8572",
  null
  
)

export default component.exports